export default function TempsText(){
  return(
    <div>
      Template Text coming soon!
    </div>
  );
}